class DateUtils {
    /**
     * Parse month-year format like "July 2025" into a Date object
     * @param str - String to parse
     * @returns Date object or null if parsing fails
     */
    static parseMonthYear(str: string): Date | null {
        try {
            const parsed = new Date(str);
            if (!isNaN(parsed.getTime())) {
                return parsed;
            }
            return null;
        } catch {
            return null;
        }
    }

    /**
     * Sort an array of objects chronologically by a date field
     * @param data - Array of objects to sort
     * @param dateField - Field name containing the date string
     * @returns Sorted array or original array if dates cannot be parsed
     */
    static sortByDateField<T extends Record<string, any>>(data: T[], dateField: keyof T): T[] {
        if (!data?.length) return data;

        const firstValue = data[0]?.[dateField];
        if (!firstValue || typeof firstValue !== 'string') return data;

        // Check if first value is a date format
        const testDate = DateUtils.parseMonthYear(firstValue);
        if (!testDate) return data;

        // Sort by date
        return [...data].sort((a, b) => {
            const dateA = DateUtils.parseMonthYear(a[dateField]);
            const dateB = DateUtils.parseMonthYear(b[dateField]);
            if (!dateA || !dateB) return 0;
            return dateA.getTime() - dateB.getTime();
        });
    }
}

export { DateUtils };
